import { useEffect } from 'react';

import { SCAN_EVENT_QUEUE } from '../constants/scanEventQueue.const';
import { createRawScanEvent } from '../utils/createRawScanEvent.util';
import { createScanDetector } from '../utils/scanDetector.util';

/**
 * Mounts scan detection and enqueues raw events.
 * `onScan` wiring to the processor is deferred until QPACK-458 (`useScanEventProcessor`);
 * until then this hook is the sole queue producer per the LLD.
 */
export const useScanDetection = () => {
  useEffect(() => {
    const detector = createScanDetector({
      onScan: (barcodeValue) => {
        SCAN_EVENT_QUEUE.enqueue(createRawScanEvent(barcodeValue));
      },
    });

    detector.start();

    return detector.stop;
  }, []);
};
